import React from 'react';
import {Grid, Paper} from '@material-ui/core'
import {APP_DOMAIN_PREFIX} from '../../../environment';


function Index(props) {
  let ip = localStorage.getItem("ip");
  ip = JSON.parse(ip)
  return (
    <Paper elevation={1} className='weather-container'>
      <Grid container>
        <Grid direction='row' container justify='space-between' className='pl-20 pr-20'>
          <Grid>
            <h2 className='text-capitalize  font-30 mb-0'>{ip.city || 'islamabad'}</h2>
            <div className='display-flex  mb-0  font-80'
                 style={{marginTop: -5}}>{parseInt(props?.weather[0]?.main?.temp_current_celcius)}<sup
              className='font-30 mt-5'>o</sup></div>
            <p className='mt-0'> Feels Like {25}<sup className='font-12 mt-5'>o</sup></p>
          </Grid>
          <Grid>
            <Grid container direction='column' alignItems='flex-end' className='mt-20'>
              <img src={APP_DOMAIN_PREFIX + '/userImages/' + props?.weather[0]?.weather[0]?.icon + '@2x.png'}
                   alt='sun'/>
              <p className='mb-0 mt-10 text-bold text-capitalize'>Humidity 25</p>
              <p className='mb-0 mt-10 text-bold text-capitalize'>{props?.weather[0]?.weather[0]?.main}</p>
              <p className='mt-10'>H:{parseInt(props?.weather[0]?.main?.temp_max_celcius)}°
                L:{parseInt(props?.weather[0]?.main?.temp_min_celcius)}°</p>
            </Grid>
          </Grid>
        </Grid>
        <Grid direction='row' container justify='space-between' className='p-20 pt-0'>
          {props.weather.map((item, index) => {
            var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            var d = new Date(item.dt_txt);
            var dayName = days[d.getDay()];
            let date = item.dt_txt.split(" ")
            return (
              <Grid key={index + item}>
                {date[1] === "15:00:00" &&
                <>
                  <h4 className='text-uppercase mt-0 mb-5'>{dayName}</h4>
                  <p className='mt-0 font-10 mb-0'> Humidity {25}<sup className='font-12 mt-5'>o</sup></p>
                  <div className='display-flex align-items-center'>
                    <p className='mt-0 font-10 mb-0'> Min {25}<sup className='font-10 mt-5'>o</sup></p>
                    <p className='mt-0 font-10 ml-2 mb-0 '> Max {25}<sup className='font-10 mt-5'>o</sup></p>
                  </div>
                  <img src={APP_DOMAIN_PREFIX + '/userImages/' + item?.weather[0]?.icon + '@2x.png'} alt='sun'/>
                  <p className='font-16'>{parseInt(item?.main?.temp_current_celcius)}<sup className='ml-2'>o</sup></p>
                </>
                }
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default Index;
